import React from 'react';
import {Dropdown, Input, Layout, Menu} from 'antd';
import './index.style.less';
import {FiMoreVertical} from 'react-icons/fi';

import AppNotifications from '../../AppNotifications';
import NotificationBar from './NotificationBar';
import {AiOutlineMenu} from 'react-icons/ai';
import PropTypes from 'prop-types';
import AppHorizontalNav from '../components/AppHorizontalNav';
import AppLogo from '../components/AppLogo';
import UserInfo from '../components/UserInfo';
import {useSidebarContext} from '../../../../contexts/AppContextProvider/SidebarContextProvider';
import {useTranslation} from 'react-i18next';

const AppHeader = ({showDrawer}) => {
  const {Header} = Layout;
  const {Search} = Input;
  const {t} = useTranslation();

  const {sidebarColorSet} = useSidebarContext();

  const menuMobile = (
    <Menu>
      <AppNotifications />
    </Menu>
  );

  return (
    <Header
      className='app-header-hor-dark'
      style={{
        backgroundColor: sidebarColorSet.sidebarBgColor,
        color: sidebarColorSet.sidebarTextColor,
      }}>
      <NotificationBar />

      <div
        className='header-hor-dark-main'
        style={{
          backgroundColor: sidebarColorSet.sidebarBgColor,
          color: sidebarColorSet.sidebarTextColor,
        }}>
        <div className='container'>
          <div className='header-hor-dark-main-flex'>
            <a className='trigger' onClick={showDrawer}>
              <AiOutlineMenu />
            </a>
            <AppLogo hasSidebarColor />
            <Search
              className='header-search-hor-dark'
              placeholder={t('int-enter-search-text')}
            />

            <div className='app-header-hor-dark-sectionDesktop'>
              <AppNotifications />
            </div>
            <UserInfo />
            <div className='app-header-hor-dark-section-mobile'>
              <Dropdown overlay={menuMobile} trigger={['click']}>
                <a
                  className='ant-dropdown-link'
                  onClick={(e) => e.preventDefault()}>
                  <FiMoreVertical />
                </a>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <div
        className='header-nav-hor-dark'
        style={{
          backgroundColor: sidebarColorSet.sidebarBgColor,
          color: sidebarColorSet.sidebarTextColor,
        }}>
        <div className='container'>
          <AppHorizontalNav className='app-main-hor-dark-menu' />
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;

AppHeader.propTypes = {
  showDrawer: PropTypes.func,
};
